import PropTypes from 'prop-types'
import {useFormContext, Controller} from 'react-hook-form'
import {InputAdornment, Box} from '@mui/material'
import {useState} from 'react'

import TextInput from './TextInput'
import MaskTextButton from '../MaskTextButton'
import PasswordRequirements from './PasswordRequirements'
import './password.scss'

const Password = ({
  ariaLabel,
  label,
  name,
  placeholder,
  showRequirements = true,
  validationRules = {}
}) => {
  const [showPassword, setShowPassword] = useState(false)
  const [showFlyout, setShowFlyout] = useState(false)
  const {control, formState: {errors}} = useFormContext()

  return (
    <Box
      className='password-field-container'
      onFocus={() => setShowFlyout(true)}
      onBlur={() => setShowFlyout(false)}
    >
      <Controller
        name={name}
        control={control}
        defaultValue=''
        rules={{
          required: 'Please add a password.',
          maxLength: {
            value: 128,
            message: 'Password is too long. Maximum length is 128 characters.'
          },
          validate: (value) => {
            if (/^\s*$/.test(value || '')) return 'Password cannot contain only spaces.'
            return validationRules.validate ? validationRules.validate(value) : true
          }
        }}
        render={({field}) => (
          <TextInput
            {...field}
            ariaLabel={ariaLabel}
            inputProps={{maxLength: 128}}
            autoComplete='new-password'
            id={name}
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  <MaskTextButton
                    showText={showPassword}
                    toggleButton={() => setShowPassword(!showPassword)}
                  />
                </InputAdornment>
              )
            }}
            label={label}
            type={showPassword ? 'text' : 'password'}
            error={!!errors[name]}
            helperText={errors[name]?.message}
            placeholder={placeholder}
          />
        )}
      />
      {showRequirements && showFlyout && (
        <PasswordRequirements />
      )}
    </Box>
  )
}

Password.propTypes = {
  ariaLabel: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  showRequirements: PropTypes.bool,
  validationRules: PropTypes.shape({
    validate: PropTypes.func
  })
}

export default Password
